/* English */
const en = {
  "nav.home":      "Home",
  "nav.plans":     "Plans",
  "nav.devices":   "Devices",
  "nav.app":       "Get the app",
  "nav.dashboard": "Dashboard",
  "nav.login":     "Sign in",
  "nav.register":  "Sign up",
  "nav.logout":    "Sign out",
  "nav.account":   "Account",

  "hero.kicker":      "Unlimited entertainment",
  "hero.title":       "Bring the cinema home.",
  "hero.subtitle":    "The most popular live TV channels, plus hundreds of movies and shows. 4K quality. On every device you own. One subscription.",
  "hero.cta.primary": "See plans",
  "hero.cta.ghost":   "I'm already a member",
  "hero.trust":       "Secure 24/7 card payment • Instant activation • Cancel anytime",

  "section.features.kicker":   "Why us",
  "section.features.title":    "A premium streaming experience.",
  "feature.4k.title":          "4K UHD quality",
  "feature.4k.desc":           "Cinema-grade picture on supported titles.",
  "feature.library.title":     "Huge library",
  "feature.library.desc":      "Movies, series, documentaries, live sports and much more.",
  "feature.devices.title":     "Every device",
  "feature.devices.desc":      "Android, iOS, Smart TV, Fire TV, Apple TV and more.",
  "feature.support.title":     "24/7 support",
  "feature.support.desc":      "Real humans — no bots. Average 5-minute response time.",

  "section.plans.kicker":      "Plans",
  "section.plans.title":       "Pick a duration that fits you.",
  "section.plans.subtitle":    "Longer plans cost less per month. Cancel anytime.",

  "section.cta.title":         "Make tonight a movie night.",
  "section.cta.subtitle":      "Sign up in seconds, stream instantly.",
  "section.cta.button":        "Get started",

  "plans.page.title":          "Plans",
  "plans.page.subtitle":       "3, 6 or 12 months. Choose what suits you.",
  "plans.months":              "{n} months",
  "plans.per_month":           "/mo",
  "plans.billed_total":        "{amount} billed once",
  "plans.select":              "Choose this plan",
  "plans.current":             "Your current plan",
  "plans.badge.popular":       "Most popular",
  "plans.badge.best_value":    "Best value",

  "feature.channels_12k":      "Wide live channel lineup",
  "feature.vod_library":       "Full VOD library",
  "feature.fhd_1080p":         "Full HD 1080p",
  "feature.uhd_4k":            "4K UHD on supported titles",
  "feature.two_devices":       "Up to 2 devices",
  "feature.three_devices":     "Up to 3 devices",
  "feature.five_devices":      "Up to 5 devices",
  "feature.seven_day_epg":     "7-day EPG",
  "feature.fourteen_day_epg":  "14-day EPG",
  "feature.priority_support":  "Priority support",
  "feature.early_access":      "Early access to new features",

  "auth.login.title":          "Welcome back.",
  "auth.login.subtitle":       "Sign in to keep streaming.",
  "auth.register.title":       "Create your account.",
  "auth.register.subtitle":    "Start your subscription in 30 seconds.",
  "auth.forgot.title":         "Forgot your password?",
  "auth.forgot.subtitle":      "Enter your email and we'll send a reset link.",
  "auth.field.email":          "Email",
  "auth.field.password":       "Password",
  "auth.field.name":           "Full name",
  "auth.field.confirm":        "Password (confirm)",
  "auth.submit.login":         "Sign in",
  "auth.submit.register":      "Create account",
  "auth.submit.forgot":        "Send reset link",
  "auth.forgot.link":          "Forgot password",
  "auth.no_account":           "Don't have an account?",
  "auth.has_account":          "Already have an account?",
  "auth.back_to_login":        "Back to sign in",
  "auth.terms":                "By signing up you agree to our {terms} and {privacy}.",
  "auth.terms.terms":          "Terms of Service",
  "auth.terms.privacy":        "Privacy Policy",
  "auth.forgot.sent":          "Link sent. Check your inbox.",

  "dash.hello":                "Hello, {name}",
  "dash.welcome":              "Manage your subscription and devices here.",
  "dash.subscription.title":   "Your subscription",
  "dash.subscription.plan":    "Plan",
  "dash.subscription.status":  "Status",
  "dash.subscription.active":  "ACTIVE",
  "dash.subscription.expires": "Expires on",
  "dash.subscription.days":    "{n} days left",
  "dash.subscription.renew":   "Renew",
  "dash.subscription.upgrade": "Upgrade",
  "dash.subscription.none":    "You don't have an active subscription yet. Choose your first plan and dive in.",
  "dash.subscription.cta":     "Choose a plan",

  "dash.devices.title":        "Devices",
  "dash.devices.count":        "{n} / {max} active",
  "dash.devices.manage":       "Manage",

  "dash.account.title":        "Account",
  "dash.account.email":        "Email",
  "dash.account.member":       "Member since",

  "dash.quick.app":            "Download the app",
  "dash.quick.plans":          "See plans",
  "dash.quick.support":        "Get help",

  "devices.title":             "Device Management",
  "devices.subtitle":          "Devices currently allowed to stream on your account.",
  "devices.add":               "Add device",
  "devices.name":              "Device",
  "devices.platform":          "Platform",
  "devices.last_seen":         "Last seen",
  "devices.added":             "Added",
  "devices.revoke":            "Revoke",
  "devices.empty.title":       "No devices yet",
  "devices.empty.subtitle":    "Install the app, then enter the 6-digit pairing code shown on screen here.",
  "devices.add.title":         "Add a new device",
  "devices.add.desc":          "Open the app on your TV or phone, then enter the 6-digit code shown on screen.",
  "devices.add.code":          "Pairing code",
  "devices.add.submit":        "Pair",
  "devices.add.hint":          "The code is 6 digits, numeric only.",
  "devices.revoke.title":      "Revoke device",
  "devices.revoke.desc":       "{name} will be signed out from your account and will need a new code to return.",
  "devices.revoke.confirm":    "Revoke",
  "devices.revoke.cancel":     "Cancel",

  "app.title":                 "Download the app",
  "app.subtitle":              "On every device you own. Same account, same subscription.",
  "app.detected":              "Your device detected:",
  "app.download":              "Download",
  "app.qr.title":              "Scan with your phone",
  "app.qr.desc":               "Scan the QR code to install the mobile app from the store.",
  "app.platform.android":      "Android",
  "app.platform.ios":          "iOS",
  "app.platform.android_tv":   "Android TV",
  "app.platform.fire_tv":      "Fire TV",
  "app.platform.apple_tv":     "Apple TV",
  "app.platform.samsung_tv":   "Samsung Smart TV",
  "app.platform.lg_tv":        "LG webOS",
  "app.platform.windows":      "Windows",
  "app.platform.mac":          "macOS",
  "app.platform.web":          "Web",
  "app.platform.desktop":      "Desktop",

  "footer.copyright":          "© {year} {brand}. All rights reserved.",
  "footer.terms":              "Terms",
  "footer.privacy":            "Privacy",
  "footer.support":            "Support",
  "footer.status":             "Status",

  "common.cancel":             "Cancel",
  "common.save":               "Save",
  "common.loading":            "Loading…",
  "common.error":              "Something went wrong",
};

export default en;
